import type { AmbleContent } from "..";
import { insurerLogosAmbles } from "./insurerLogos";

/**
 * UK-specific ambles for SimpleBusiness UK
 */
export const simplybusinessUkAmbles: Record<string, AmbleContent> = {
  ...insurerLogosAmbles,
};
